// extracted by mini-css-extract-plugin
export default {"container":"CustomerManagement_container__VZ7cP","wrapperHeader":"CustomerManagement_wrapperHeader__Zx58L"};